<template>
  <div>
    formulaire de consultation

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>